import find from 'lodash/find';
import map from 'lodash/map';
import React from 'react';
import { Select } from '../../../../base-components/Select';
import { Region } from '../../../../types/entities';

interface RegionOption {
    value: string;
    label: string;
}

interface Props {
    instanceId: string;
    regions: Region[];
    value: Region | null;
    onChange: (value: Region | null) => void;
    className?: string;
}

/**
 * Селектор региона
 */
export const SelectRegion: React.FC<Props> = ({
    instanceId,
    regions,
    value: externalValue,
    onChange: externalOnChange,
    className,
}) => {
    const options: RegionOption[] = map(regions, (region) => ({
        value: region.regionCode,
        label: [region.offName, region.shortName].filter(Boolean).join(' '),
    }));

    const selectValue: RegionOption | null = externalValue
        ? find(options, ['value', externalValue.regionCode]) || null
        : null;

    const handleChange = (selectedOption: RegionOption | null) => {
        const selectedBlock: Region | null = selectedOption
            ? find(regions, ['regionCode', selectedOption.value]) || null
            : null;
        externalOnChange?.(selectedBlock);
    };

    return (
        <Select
            instanceId={instanceId}
            placeholder="Регион"
            value={selectValue}
            onChange={handleChange}
            options={options}
            className={className}
            isMulti={false}
            isSearchable={true}
        />
    );
};
